import React from 'react'
import './App.css'

import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { BrowserRouter as Router } from 'react-router-dom'

import dayjs from '@date-io/dayjs'
import ru from 'dayjs/locale/ru'

import Auth from '../Auth'
import Fire from '../Fire'
import Routes from '../Routes'

function App() {
    return (
        <MuiPickersUtilsProvider utils={dayjs} locale={ru}>
            <Router>
                <Auth>
                    <Fire>
                        <Routes />
                    </Fire>
                </Auth>
            </Router>
        </MuiPickersUtilsProvider>
    )
}

export default App
